import { createFileRoute, Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ArrowRight, Images } from "lucide-react";

import { listQuery } from "@/lib/queries";
import { PageHero, Section, EmptyState } from "@/components/site/bits";

export const Route = createFileRoute("/galeria")({
  head: () => ({
    meta: [
      { title: "Galeria | Professor Rurdiney — 40123" },
      {
        name: "description",
        content: "Fotos da campanha, eventos e ações do Professor Rurdiney, candidato a vereador nº 40123.",
      },
      { property: "og:title", content: "Galeria | Professor Rurdiney — 40123" },
      {
        property: "og:description",
        content: "Confira os álbuns de fotos da campanha do Professor Rurdiney.",
      },
    ],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(listQuery("galleries")),
  component: GaleriaPage,
});

function GaleriaPage() {
  const { data: galleries } = useSuspenseQuery(listQuery("galleries"));

  return (
    <>
      <PageHero
        eyebrow="Registros"
        title="Galeria"
        description="Os melhores momentos da campanha registrados em imagens."
      />

      <Section>
        {galleries.length === 0 ? (
          <EmptyState message="Nenhum álbum publicado ainda." />
        ) : (
          <div className="grid gap-6 md:grid-cols-3">
            {galleries.map((g: any) => (
              <Link
                key={g.id}
                to="/galeria/$slug"
                params={{ slug: g.slug }}
                className="group relative flex aspect-[4/3] flex-col justify-end overflow-hidden rounded-2xl border border-border bg-primary-deep shadow-card transition-all hover:shadow-glow"
              >
                {g.cover_url ? (
                  <img
                    src={g.cover_url}
                    alt={g.title}
                    className="absolute inset-0 size-full object-cover transition-transform group-hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center bg-mesh">
                    <Images className="size-10 text-primary-foreground/40" />
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-primary-deep/90 via-primary-deep/10 to-transparent" />
                <div className="relative p-5 text-primary-foreground">
                  <h3 className="font-display text-xl">{g.title}</h3>
                  <span className="mt-1 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-accent">
                    Ver álbum <ArrowRight className="size-3.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </Section>
    </>
  );
}
